import { z } from "zod";

import { ExperienceAnalysisHistoryDtoSchema } from "../../../dtos/ai";

export const AiGetExperienceAnalysisHistoryPathParamSchema = z.object({
  experienceId: z.string().uuid(),
});

export type AiGetExperienceAnalysisHistoryPathParamType = z.infer<
  typeof AiGetExperienceAnalysisHistoryPathParamSchema
>;

export const AiGetExperienceAnalysisHistoryResponseSchema = z.object({
  history: ExperienceAnalysisHistoryDtoSchema.array(),
});

export type AiGetExperienceAnalysisHistoryResponseBodyType = z.infer<
  typeof AiGetExperienceAnalysisHistoryResponseSchema
>;
